var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { cn } from '../../lib/utils.js';
// Added from: https://github.com/shadcn-ui/ui/discussions/1694#discussioncomment-7851248
export var LoadingSpinner = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 24 : _b, className = _a.className, props = __rest(_a, ["size", "className"]);
    return (<svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} {...props} viewBox="0 0 24 24" fill="none" stroke="var(--primary)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={cn('animate-spin', className)}>
      <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
    </svg>);
};
